export default __webpack_public_path__ + "static/media/Deathmaven Heavy Helm.170e18d6.jpg";